import { render, staticRenderFns } from "./CreateRichTextView.vue?vue&type=template&id=d7a68666&scoped=true&"
import script from "./CreateRichTextView.vue?vue&type=script&lang=ts&"
export * from "./CreateRichTextView.vue?vue&type=script&lang=ts&"
import style0 from "./CreateRichTextView.vue?vue&type=style&index=0&id=d7a68666&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a68666",
  null
  
)

export default component.exports